import { PROVENANCE_LABEL } from "../lib/provenance";

export function ProvenanceFooter() {
  return (
    <footer
      data-cogo-section="ProvenanceFooter"
      className="mt-20 border-t border-white/5 py-8 px-2 text-xs text-slate-500 flex flex-col sm:flex-row justify-between items-center gap-4 font-sans"
    >
      <div className="flex items-center gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" />
        <span className="font-mono">{PROVENANCE_LABEL}</span>
      </div>
      <div className="flex gap-4 font-mono text-[10px] text-slate-600">
        <span>SCHEMA: V4.0</span>
        <span>ENGINE: COGO-V77-RUNTIME</span>
      </div>
    </footer>
  );
}
